import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { EmployeesActions } from '../actions';
import { EmployeesActionsUnion } from '../actions/employees.actions';
import { Employee } from '../models';

export interface EmployeesState extends EntityState<Employee> {
  selectedId: string;
  loading: boolean;
  loaded: boolean;
}

export const employeesAdapter: EntityAdapter<Employee> = createEntityAdapter<Employee>({
  selectId: (employee: Employee) => employee?.slug,
  sortComparer: (a: Employee, b: Employee) => a?.name?.localeCompare(b?.name)
});

const initialState: EmployeesState = employeesAdapter.getInitialState({
  selectedId: null,
  loading: false,
  loaded: false
});

const reducer = createReducer(
  initialState,

  on(EmployeesActions.clear, () => initialState),

  on(EmployeesActions.select, (state, { employee: { employeeId } }) => ({
    ...state,
    selectedId: employeeId
  })),

  on(EmployeesActions.subscribe, (state) => ({
    ...state,
    loading: true
  })),

  on(EmployeesActions.set, (state, { employees }) =>
    employeesAdapter.setAll(employees || [], {
      ...state,
      loading: false,
      loaded: true
    })
  )
);

export function employeesReducer(state: EmployeesState, action: EmployeesActionsUnion) {
  return reducer(state, action);
}
